"use strict";

exports.__esModule = true;
exports.default = void 0;

var _inputGroup = _interopRequireDefault(require("./input-group"));

var _inputGroupAddon = _interopRequireDefault(require("./input-group-addon"));

var _inputGroupPrepend = _interopRequireDefault(require("./input-group-prepend"));

var _inputGroupAppend = _interopRequireDefault(require("./input-group-append"));

var _inputGroupText = _interopRequireDefault(require("./input-group-text"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BInputGroup: _inputGroup.default,
  BInputGroupAddon: _inputGroupAddon.default,
  BInputGroupPrepend: _inputGroupPrepend.default,
  BInputGroupAppend: _inputGroupAppend.default,
  BInputGroupText: _inputGroupText.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/input-group/index.js
// module id = 508
// module chunks = 7